export const ALERTS_ACTION = {

    RESET_ALERTS_LIST_STATE: 'RESET_ALERTS_LIST_STATE',
    REQUEST_ALERTS_LIST:"REQUEST_ALERTS_LIST",
    RESPONSE_ALERTS_LIST:"RESPONSE_ALERTS_LIST",
    ERROR_ALERTS_LIST:"ERROR_ALERTS_LIST",

RESET_SIDE_NAV_STATE :"RESET_SIDE_NAV_STATE",
TOOGLE_SIDE_NAV_STATE :"TOOGLE_SIDE_NAV_STATE",

  };

  export const setResetSideNavState = () => ({
    type: ALERTS_ACTION.RESET_SIDE_NAV_STATE,
    data: undefined
  });

  export const setToogleSideNavState = () => ({
    type: ALERTS_ACTION.TOOGLE_SIDE_NAV_STATE,
    data: undefined
  });
  
  export const setResetStateAlertList = () => ({
    type: ALERTS_ACTION.RESET_ALERTS_LIST_STATE,
    data: undefined
  });
  
  export const requestAlertListAction = (params) =>({
    type: ALERTS_ACTION.REQUEST_ALERTS_LIST,
    data: params
  })
  export const responseAlertListAction = (res) => ({
    type: ALERTS_ACTION.RESPONSE_ALERTS_LIST,
    data: res
  });
  
  export const errorAlertsListAction = (err) => ({
    type: ALERTS_ACTION.ERROR_ALERTS_LIST,
    data: err
  });